(function () {
  const CACHE = new Map();
  const LIMIT = 250;
  const AVAILABILITY_PARAM = 'filter.v.availability';

  function getCollectionProductsUrl(page) {
    const path = window.location.pathname.replace(/\/$/, '');
    if (!path.includes('/collections/')) return null;

    return `${path}/products.json?limit=${LIMIT}&page=${page}`;
  }

  async function fetchCollectionAvailabilityCounts() {
    const cacheKey = window.location.pathname.replace(/\/$/, '');
    if (CACHE.has(cacheKey)) return CACHE.get(cacheKey);

    const countsPromise = (async () => {
      let page = 1;
      let inStock = 0;
      let outOfStock = 0;

      while (true) {
        const url = getCollectionProductsUrl(page);
        if (!url) break;

        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) break;

        const data = await response.json();
        const products = Array.isArray(data.products) ? data.products : [];
        if (products.length === 0) break;

        products.forEach((product) => {
          const variants = Array.isArray(product.variants) ? product.variants : [];
          const hasAvailableVariant = variants.some((variant) => variant.available);

          if (hasAvailableVariant) {
            inStock += 1;
          } else {
            outOfStock += 1;
          }
        });

        if (products.length < LIMIT) break;
        page += 1;
      }

      return {
        inStock,
        outOfStock,
        total: inStock + outOfStock
      };
    })();

    CACHE.set(cacheKey, countsPromise);
    return countsPromise;
  }

  function updateAvailabilityOption(input, count) {
    const label = input.closest('label');
    if (!label) return;

    const countElement = label.querySelector('.caption-with-letter-spacing');
    if (countElement) {
      const countText = `(${count})`;
      if (countElement.textContent !== countText) {
        countElement.textContent = countText;
      }
    }

    const shouldDisable = count === 0 && !input.checked;
    input.disabled = shouldDisable;
    label.classList.toggle('facet-checkbox--disabled', shouldDisable);
    label.classList.toggle('mobile-facets__label--disabled', shouldDisable);
  }

  function updateProductCount(counts) {
    const selectedAvailability = new URLSearchParams(window.location.search).getAll(AVAILABILITY_PARAM);
    if (selectedAvailability.length !== 1) return;

    let activeCount = null;
    if (selectedAvailability[0] === '0') {
      activeCount = counts.outOfStock;
    } else if (selectedAvailability[0] === '1') {
      activeCount = counts.inStock;
    }

    if (activeCount === null) return;

    document
      .querySelectorAll('#ProductCount, #ProductCountDesktop, #ProductCountMobile')
      .forEach((element) => {
        const countText = `${activeCount} of ${counts.total} products`;
        if (element.textContent.trim() !== countText) {
          element.textContent = countText;
        }
      });
  }

  async function updateAvailabilityFacetCounts() {
    const availabilityInputs = document.querySelectorAll(`input[name="${AVAILABILITY_PARAM}"]`);
    if (availabilityInputs.length === 0) return;

    try {
      const counts = await fetchCollectionAvailabilityCounts();

      availabilityInputs.forEach((input) => {
        if (input.value === '0') {
          updateAvailabilityOption(input, counts.outOfStock);
        } else if (input.value === '1') {
          updateAvailabilityOption(input, counts.inStock);
        }
      });

      updateProductCount(counts);
    } catch (error) {
      // Keep Shopify's native counts if the collection JSON is unavailable.
    }
  }

  document.addEventListener('DOMContentLoaded', updateAvailabilityFacetCounts);
  document.addEventListener('shopify:section:load', updateAvailabilityFacetCounts);

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;

    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      updateAvailabilityFacetCounts();
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
